import * as React from 'react';

import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from '@mui/material/FormControl';
import IconButton from "@mui/material/IconButton";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ReportClockTimeDialog from './clock/ReportClockTimeDialog';
import Select from '@mui/material/Select';
import WalkStageEditDialog from './walks/WalkStageEdit';
import { getPlaceImage } from './lib/placeImage';
import { isUserLoggedIn } from './lib/authentication';
import { sentenceCase } from "./lib/text";

const InfoView = (props) => {
  const { place, geo, allowGeo, setIsFullscreen, onWalk, setOnWalk, myWalks } = props;
  const { onClose, open } = props;
  const [editWalkViewShow, setEditWalkViewShow] = React.useState(false);
  const [name, setName] = React.useState("");
  const [walkid, setWalkid] = React.useState(0)
  const [reportTimeOpen, setReportTimeOpen] = React.useState(false);
  const handleClick = () => {
    allowGeo(true);

    setIsFullscreen(true);
  };
  const handleInfoClose = () => {
    onClose();
  };
  const handleWalkStageEditClose = () => {
    setEditWalkViewShow(false);
  };
  const handleChange = (e, c) => {

    setName(e.target.value)
    setWalkid(c.props.walkid)

    setEditWalkViewShow(true)

    //WalkStageEditDialog(e.target.value, e.target.key, place)
  }
  const WalkSelector = () => {
    if (isUserLoggedIn()) {
      return (
        <div>
        <FormControl fullWidth>
          <InputLabel id="add-to-walk-select-label">Add to Walk</InputLabel>
          <Select
            labelId="add-to-walk-select-label"
            id="add-to-walk-select"
            label="Add to Walk"
            onChange={handleChange}
          >
            {myWalks.map(item => (<MenuItem key={item.id} walkid={item.id} value={item.name}>{item.name}</MenuItem>))}
          </Select>
        </FormControl>
        <WalkStageEditDialog open={editWalkViewShow} onClose={handleWalkStageEditClose} name={name} place={place} walkid={walkid} />
        </div>
      )
    }
  }
  if (place) {
    let { title, description, thumb, canonicalurl, sourceKey } = place;
    const isClock = sourceKey === 'hands_on_time';
    const image = getPlaceImage(thumb, sourceKey);
    const wikiLink = `https://www.wikipedia.org/search-redirect.php?search=${encodeURIComponent(
      title
    )}&family=wikipedia&hiddenLanguageInput=en`;
    return (
      <Dialog
        onClose={handleInfoClose}
        aria-labelledby="settings-dialog-title"
        open={open}
        autoComplete="off"
      >
        <DialogTitle id="settings-dialog-title" className="dialogTitle">
          {sentenceCase(title)}
          <IconButton onClick={onClose}>
          <CloseIcon style={{ color: "#ff334b" }}/>
        </IconButton>
        </DialogTitle>

        <div className="App-info-container">
          <img
            src={image.url}
            alt={sentenceCase(title)}
            className={image.isPlaceholder ? 'App-info-placeholder' : undefined}
          />
          {description ? <p>{sentenceCase(description)}</p> : null}
          <p>
            <a target="_blank" rel="noopener noreferrer" href={canonicalurl}>
              See more about this (In New Tab).
            </a>
          </p>
          {isClock ? (
            <p>
              <Button variant="outlined" onClick={() => setReportTimeOpen(true)}>
                Report time
              </Button>
            </p>
          ) : null}
          <WalkSelector myWalks={myWalks} />
          {isClock ? (
            <ReportClockTimeDialog open={reportTimeOpen} onClose={() => setReportTimeOpen(false)} place={place} />
          ) : null}
        </div>
      </Dialog>
    );
  } else {
    return (
      <div className="App-info-container">
        <h1>
          {geo ? (
            <button disabled>Location shared!</button>
          ) : (
            <button onClick={handleClick}>Share Location</button>
          )}
        </h1>
        <article>
          <p>
            <strong>Click “Share Location”</strong> to discover interesting
            landmarks around you from Veracity.
          </p>
          <p>
            <strong>Tap on a marker</strong> on the map and more information
            about it will show up in this space.
          </p>
        </article>
      </div>
    );
  }
};

export default InfoView;
